import DgTable from 'styles/UI/Table/DgTable';
import userAdminWalletSettings from '../hooks/userAdminWalletSettings';
import useQueryNoLocation from 'core/hooks/useNoQueryUrlParam';
import DgPagination from 'styles/UI/Pagination/DgPagination';
import { paginateDataHandler } from 'core/utils/utils';
import DgModal from 'styles/UI/Modal/DgModal';
import AdminWalletSettingsUpdate from './AdminWalletSettingsUpdate';
import AdminWalletSettingsTableColumn from './AdminWalletSettingsTableColumn';

const AdminWalletSettingsTable = () => {
	const {
		settings,
		settingIsLoading,
		onEditSettingsHandler,
		onHiddenModalHandler,
		modal,
	} = userAdminWalletSettings();
	const { handlePagination, page, per_page } = useQueryNoLocation();

	return (
		<>
			<DgModal
				title='setting-update'
				width={1000}
				open={modal}
				onCancel={onHiddenModalHandler}
			>
				<AdminWalletSettingsUpdate />
			</DgModal>
			<DgTable
				rowKey='id'
				columns={AdminWalletSettingsTableColumn(onEditSettingsHandler)}
				dataSource={paginateDataHandler(settings?.data || [], page, per_page)}
				count={settings?.data.length}
				loading={settingIsLoading}
				current={page}
				per_page={per_page}
			/>

			<DgPagination
				onPaginationHandler={handlePagination}
				responsive={true}
				per_page={per_page}
				current={page}
				total={settings?.data.length}
			/>
		</>
	);
};

export default AdminWalletSettingsTable;
